import { LoadCircle, LoadCircleInner, LoadInner, SpinnerRoot } from './styles';

import { CenterItem } from '@components/LinearLayout';

interface SpinnerProps {
  size?: string;
}

const Spinner = ({ size }: SpinnerProps) => {
  return (
    <CenterItem>
      <SpinnerRoot size={size}>
        <LoadInner>
          <LoadCircle>
            <LoadCircleInner />
          </LoadCircle>
          <LoadCircle>
            <LoadCircleInner />
          </LoadCircle>
          <LoadCircle>
            <LoadCircleInner />
          </LoadCircle>
          <LoadCircle>
            <LoadCircleInner />
          </LoadCircle>
          <LoadCircle>
            <LoadCircleInner />
          </LoadCircle>
        </LoadInner>
      </SpinnerRoot>
    </CenterItem>
  );
};

export default Spinner;
